"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPS = exports.HTTP = exports.DOMAIN_COPILOT_API_B = exports.DOMAIN_COPILOT_API = exports.DOMAIN_API_WPS = exports.DOMAIN_365_KDOCS = exports.DOMAIN_KDOCS = exports.ENCRYPT_RETRY_TIME = exports.ENCRYPT_V5_PATH = exports.CHARSET = void 0;
// --------------- 无法分类 ---------------
exports.CHARSET = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
exports.ENCRYPT_V5_PATH = '/office/v5/commons/security/encryption/info?app_key=wpsai';
exports.ENCRYPT_RETRY_TIME = 60000;
// --------------- 请求相关 ---------------
exports.DOMAIN_KDOCS = 'www.kdocs.cn';
exports.DOMAIN_365_KDOCS = '365.kdocs.cn';
exports.DOMAIN_API_WPS = 'api.wps.cn';
exports.DOMAIN_COPILOT_API = 'copilot-api.wps.cn';
exports.DOMAIN_COPILOT_API_B = 'copilot-api-b.wps.cn';
exports.HTTP = 'http://';
exports.HTTPS = 'https://';
